export enum ActionTypes {
    // Status
    LOADED = "LOADED",
    NOT_LOADED = "NOT_LOADED",
    IS_LOADING = "IS_LOADING",
    LOADING_FAILED = "LOADING_FAILED",

    // Fetch featured jobs
    FETCH_JOBS_LOADING = "FETCH_JOBS_LOADING",
    FETCH_JOBS = "FETCH_JOBS",
    FETCH_JOBS_SUCCESS = "FETCH_JOBS_SUCCESS",
    FETCH_JOBS_ERROR = "FETCH_JOBS_ERROR",
    CLEAR_JOBS = "CLEAR_JOBS",

    // Fetch details
    FETCH_JOB_DETAILS_LOADING = "FETCH_JOB_DETAILS_LOADING",
    FETCH_JOB_DETAILS = "FETCH_JOB_DETAILS",
    FETCH_JOB_DETAILS_SUCCESS = "FETCH_JOB_DETAILS_SUCCESS",
    FETCH_JOB_DETAILS_ERROR = "FETCH_JOB_DETAILS_ERROR",

    // Fetch jobs based on filters
    FETCH_JOBS_BY_FILTER_LOADING = "FETCH_JOBS_BY_FILTER_LOADING",
    FETCH_JOBS_BY_FILTER = "FETCH_JOBS_BY_FILTER",
    FETCH_JOBS_BY_FILTER_SUCCESS = "FETCH_JOBS_BY_FILTER_SUCCESS",
    FETCH_JOBS_BY_FILTER_ERROR = "FETCH_JOBS_BY_FILTER_ERROR",
}